export default __webpack_public_path__ + "static/media/6.8345d5db.jpeg";